import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

//const
import { QUERY_KEYS } from 'consts/queryKeys';
//custom hooks
import { useCustomToast } from 'hooks';
//services
import { createAutomaticStatement } from 'modules/accommodations/features/reservations/api';

interface IProps {
  showSuccessToast?: boolean;
}

export const useCalculationAutoStatementMutation = ({ showSuccessToast = true }: IProps = {}) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const { successToast, errorToast } = useCustomToast();

  const { mutate, mutateAsync, isLoading } = useMutation(createAutomaticStatement, {
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.RENTALS_CALCULATION_STATEMENTS);
      queryClient.invalidateQueries([QUERY_KEYS.UNITS_RESERVATIONS_PAYMENTS]);
      if (showSuccessToast) {
        successToast(t('Statement successfully generated.'));
      }
    },
    onError: () => errorToast(),
  });

  return {
    mutate,
    mutateAsync,
    isLoading,
  };
};
